/** Portuguese dictionary. */
const pt = {
  nav: {
    dashboard: 'Painel',
    products: 'Produtos',
    website: 'Site',
    advertorials: 'Advertoriais',
    ads: 'Anúncios',
    splitTesting: 'Testes A/B',
    findUpsells: 'Encontrar upsells',
    findProducts: 'Encontrar produtos',
    aiChat: 'Chat IA',
    referAndEarn: 'Indique e ganhe',
    settings: 'Configurações',
    notifications: 'Notificações',
    aiSuggestions: 'Sugestões de IA',
    noSuggestions: 'Ainda não há sugestões — volte em breve!',
    caughtUp: 'Está tudo em dia',
    noNotificationsBody: 'Avisaremos aqui quando uma criação terminar ou quando a IA tiver uma sugestão para a sua loja.',
    groups: {
      create: 'Criar',
      grow: 'Crescer',
      assistant: 'Assistente',
      account: 'Conta',
    },
  },
  common: {
    generate: 'Gerar',
    publish: 'Publicar',
    download: 'Baixar',
    downloadAll: 'Baixar tudo',
    save: 'Salvar',
    cancel: 'Cancelar',
    back: 'Voltar',
    next: 'Avançar',
    continue: 'Continuar',
    done: 'Concluído',
    view: 'Ver',
    edit: 'Editar',
    delete: 'Excluir',
    close: 'Fechar',
    loading: 'Carregando...',
    loadingStore: 'Carregando sua loja…',
    product: 'Produto',
    selectProduct: 'Selecione um produto',
    pleaseChooseProduct: 'Por favor escolha um produto',
    markComplete: 'Marcar como concluído',
    copyHtml: 'Copiar HTML',
    settingsSaved: 'Configurações salvas',
    alreadyGenerating: 'Isto já está sendo gerado — veja o indicador de progresso no canto inferior direito.',
    generationStarted: 'Geração iniciada — você pode sair desta página, avisaremos quando terminar.',
    open: 'Abrir',
    tryAgain: 'Tentar novamente',
    viewLive: 'Ver página publicada',
    preview: 'Pré-visualização',
  },
  dashboard: {
    suggestions: 'Sugestões de IA',
    dismiss: 'Dispensar',
    adPerformance: 'Desempenho dos anúncios — últimos 30 dias',
    badgeNew: 'Novo',
    badgeComingSoon: 'Em breve',
    metrics: {
      totalSpend: 'Gasto total',
      roas: 'ROAS',
      purchases: 'Compras',
      revenue: 'Receita',
      clicks: 'Cliques',
      ctr: 'CTR',
    },
    capabilities: {
      buildProducts: {
        title: 'Crie produtos do zero',
        desc: 'Envie uma foto ou cole uma URL — a IA cria o produto completo, imagens, preços e uma página de produto de alta conversão.',
      },
      fullWebsite: {
        title: 'Crie um site completo',
        desc: 'Página inicial, sobre, contato — uma loja completa com sua marca em torno do seu produto.',
      },
      imageAds: {
        title: 'Anúncios de imagem',
        desc: '20 criativos DTC profissionais por produto, prontos para a Meta.',
      },
      videoAds: {
        title: 'Anúncios em vídeo',
        desc: 'Anúncios em vídeo gerados por IA comprovados para converter na Meta e no TikTok.',
      },
      advertorials: {
        title: 'Advertoriais',
        desc: 'Artigos em estilo editorial que vendem — história, pesquisa, lista e mais.',
      },
      releaseAds: {
        title: 'Crie e publique anúncios',
        desc: 'A IA escreve o texto, monta a campanha e publica na sua conta da Meta.',
      },
      splitTesting: {
        title: 'Testes A/B',
        desc: 'Teste preços, ofertas, imagens, textos e páginas para descobrir o que vence.',
      },
      scaling: {
        title: 'Sugestões de escala',
        desc: 'A IA acompanha os anúncios vencedores e diz exatamente o que escalar e quando.',
      },
      winningAds: {
        title: 'Detecção de anúncios vencedores',
        desc: 'A IA encontra seus melhores anúncios e cria mais com base no que funciona.',
      },
      aiAssistant: {
        title: 'Assistente de IA',
        desc: 'Peça qualquer coisa — mudar um preço, ajustar uma página, montar um teste, escalar um anúncio.',
      },
      themeEditorAi: {
        title: 'Autonoma IA no editor de temas',
        desc: 'Clique em qualquer seção no editor de temas da Shopify e diga à IA o que mudar — em qualquer tema.',
      },
      mobileApp: {
        title: 'Gerencie pelo celular',
        desc: 'Administre sua loja e lance anúncios de onde estiver pelo app móvel.',
      },
    },
    mobileAppModal: {
      title: 'Baixe o app da Autonoma no seu celular',
      subtitle: 'Copie o link e abra no seu aparelho — ou abra a loja diretamente.',
      ios: 'iOS — App Store',
      android: 'Android — Google Play',
      open: 'Abrir',
      copyLink: 'Copiar link',
      copied: 'Copiado',
      close: 'Fechar',
    },
    title: 'Painel',
    subtitle: 'Crie produtos, páginas, anúncios e sites — e deixe a IA continuar a melhorá-los.',
    primaryAction: 'Criar um produto',
    capabilitiesTitle: 'Tudo o que a Autonoma pode fazer',
    capabilitiesSubtitle: 'Escolha uma ferramenta para começar. As funcionalidades marcadas como “Automático” funcionam sozinhas assim que os seus anúncios tiverem dados.',
    automatic: 'Automático',
    automaticHint: 'Funciona sozinha assim que os seus anúncios tiverem dados — não há nada a configurar.',
    gettingStarted: {
      title: 'Primeiros passos',
      progress: '{done} de {total} concluídos — o próximo passo está destacado.',
      hide: 'Ocultar',
      doneCta: 'Concluído',
      product: {
        title: 'Crie um produto',
        desc: 'Envie uma foto — criamos o produto, as imagens e a página.',
        cta: 'Criar um produto',
      },
      ads: {
        title: 'Crie anúncios',
        desc: 'Anúncios com imagem, anúncios em vídeo e textos para o seu produto.',
        cta: 'Criar anúncios',
      },
      meta: {
        title: 'Conecte a Meta e lance',
        desc: 'Conecte a sua conta de anúncios e publique uma campanha.',
        cta: 'Conectar Meta',
      },
      website: {
        title: 'Crie um site',
        desc: 'Uma loja completa com a sua marca em torno dos seus produtos.',
        cta: 'Criar um site',
      },
    },
  },
  ads: {
    imageN: 'Imagem {n}',
    brief: {
      label: 'Brief', open: 'Ver o brief da imagem', title: 'Brief da imagem', close: 'Fechar',
      layout: 'Layout', purpose: 'Objetivo', attempts: '{n} tentativas', textRendered: 'Texto composto por nós', compositeUsed: 'Produto real integrado',
      pass: 'aprovado', fail: 'reprovado', gateIdentity: 'Identidade', gateText: 'Texto', gateAesthetics: 'Estética', gateArrows: 'Setas',
      overlays: 'Texto na imagem (exato)', camera: 'Câmera', lighting: 'Iluminação', background: 'Fundo', negativeSpace: 'Espaço livre',
      finalPrompt: 'Prompt final', copy: 'Copiar', copied: 'Copiado',
    },
    title: 'Anúncios',
    subtitle: 'Crie, revise e publique anúncios da Meta — passo a passo',
    tabCreate: 'Criar novo',
    tabInProgress: 'Em andamento',
    tabCompleted: 'Concluídos',
    tabStrategy: 'Estratégia',
    stepSetup: 'Configuração',
    stepCreatives: 'Criativos',
    stepCopy: 'Texto',
    stepPublish: 'Publicar',
    generateAds: 'Gerar anúncios',
    clickToSelect: 'Clique nas imagens para selecioná-las.',
    campaignSetup: 'Configuração da campanha',
    campaignName: 'Nome da campanha',
    adSetName: 'Nome do conjunto de anúncios',
    dailyBudget: 'Orçamento diário',
    countries: 'Países',
    publishAds: 'Publicar anúncios',
    connectAdAccount: 'Conectar conta de anúncios',
    setup: {
      account: {
        title: 'Conecte sua conta de anúncios da Meta para publicar',
        body: 'Seus anúncios estão prontos. Para publicar é preciso uma conta de anúncios da Meta conectada — leva um minuto em Configurações; depois volte aqui.',
        cta: 'Conectar conta de anúncios',
      },
      page: {
        title: 'Selecione uma Página do Facebook para publicar',
        body: 'A Meta precisa de uma Página do Facebook para criar os criativos. Escolha uma em Configurações e depois volte aqui.',
        cta: 'Selecionar Página do Facebook',
      },
      pixel: {
        title: 'Configure seu Pixel da Meta para publicar',
        body: 'Anúncios otimizados para compra precisam do seu Pixel com o evento Compra. Configure-o em Configurações e depois volte aqui.',
        cta: 'Configurar o Pixel',
      },
    },
    connectToPublish: 'Conecte sua conta de anúncios para publicar.',
    adCopy: 'Texto do anúncio',
    generateCopy: 'Gerar texto',
    useExistingCopy: 'Usar texto existente',
    noInProgress: 'Nenhum anúncio em andamento. Comece um na aba Criar novo — seu progresso é salvo automaticamente a cada etapa.',
    noCompleted: 'Ainda não há campanhas concluídas.',
    createNewAds: 'Criar novos anúncios',
    imageAds: 'Anúncios de imagem',
    videoAds: 'Anúncios em vídeo',
    writeManually: 'Escrever manualmente',
    manualCopyTitle: 'Escreva seu próprio texto de anúncio',
    manualCopyHelp: 'O primeiro texto principal e o primeiro título são obrigatórios — os demais são opcionais mas recomendados para a Meta testar mais variações.',
    primaryText: 'Texto principal',
    headline: 'Título',
    required: 'obrigatório',
    recommended: 'recomendado',
    manualValidation: 'Adicione pelo menos o primeiro texto principal e o primeiro título para continuar.',
    emptyInProgressTitle: 'Nada em andamento',
    emptyCompletedTitle: 'Ainda não há criações de anúncios concluídas',
    emptyCompletedBody: 'As criações concluídas aparecem aqui, apenas para leitura — inicie uma em Criar novo.',
    progressTitle: 'Criando os seus anúncios',
    progressSteps: {
      study: 'Estudando as fotos do seu produto',
      design: 'Desenhando os seus criativos',
      render: 'Gerando as suas imagens',
      renderVideo: 'Gerando as suas imagens e vídeos',
      review: 'Preparando tudo para revisão',
    },
    cancelGeneration: 'Cancelar esta criação',
    cancelConfirm: 'Cancelar esta criação?',
    cancelTitle: 'Cancelar criação',
    liveTitle: 'A sua campanha está ativa 🚀',
    liveBody: '{n} anúncio(s) em circulação gastando o seu orçamento diário.',
    pausedTitle: 'A sua campanha foi criada — está desligada 🎉',
    pausedBody: 'Ainda não há gastos. Ligue-a quando estiver pronto ou reveja-a primeiro na Meta.',
    viewInAdsManager: 'Ver no Gerenciador de Anúncios',
    createMore: 'Criar mais anúncios',
    turnOnTitle: 'Ligar a campanha',
    turnOnDesc: 'Começa a gastar o seu orçamento diário imediatamente.',
    turnOn: 'Ligar',
    reviewInMetaTitle: 'Rever primeiro na Meta',
    reviewInMetaDesc: 'Confira os anúncios, o público e o orçamento no Gerenciador de Anúncios antes de gastar.',
    barTitle: 'Publicar {n} anúncio(s) na Meta',
    barActive: 'Começam a circular assim que forem publicados.',
    barPaused: 'São criados desligados — nada é gasto até você ligá-los.',
    next: {
      performance: {
        title: 'Acompanhe os resultados',
        desc: 'Gasto, ROAS e compras aparecem no seu painel assim que a Meta reportar.',
        cta: 'Ir para o painel',
      },
      split: {
        title: 'Faça um teste A/B da página de destino',
        desc: 'Teste preços, ofertas e versões de página para aumentar a conversão.',
        cta: 'Iniciar um teste A/B',
      },
    },
  },
  advertorials: {
    title: 'Advertoriais',
    subtitle: 'Gere páginas editoriais longas que parecem artigos de notícias e vendem produtos',
    generate: 'Gerar advertorial',
    publish: 'Publicar advertorial',
    published: 'Advertorial publicado!',
    createAdsQuestion: 'Criar anúncios com este ângulo?',
    yesCreateAds: 'Sim, criar anúncios',
    noThanks: 'Não, obrigado',
    tabCreate: 'Criar novo',
    tabPrevious: 'Criados anteriormente',
    allProducts: 'Todos os produtos',
    filterByProduct: 'Filtrar por produto',
    noPrevious: 'Ainda não há advertoriais — crie o primeiro na aba Criar novo.',
    editWithAi: 'Abrir e editar com IA',
    createAdsFor: 'Criar anúncios para o advertorial',
    viewLive: 'Ver página publicada',
    updated: 'Advertorial atualizado!',
    created: 'Criado',
    setupEyebrow: 'Configuração',
    setupTitle: 'Escolha um produto e um estilo',
    startError: 'Não foi possível iniciar o advertorial',
    progressTitle: 'Escrevendo o seu advertorial',
    progressSteps: {
      research: 'Pesquisando o produto e o público',
      write: 'Escrevendo o artigo',
      images: 'Criando imagens',
      layout: 'Montando a página',
    },
    reviewEyebrow: 'Revisão',
    reviewTitle: 'O seu advertorial',
    reviewHint: 'Leia tudo, clique em qualquer parte para alterar e publique quando estiver satisfeito.',
    draftLabel: 'Rascunho — ainda não publicado',
    publishError: 'Não foi possível publicar o advertorial',
    liveTitle: 'O seu advertorial está publicado 🎉',
    editInThemeEditor: 'Editar no editor de temas',
    createAnother: 'Criar outro advertorial',
    emptyTitle: 'Ainda não há advertoriais',
    next: {
      ads: {
        title: 'Crie anúncios com este ângulo',
        desc: 'Anúncios que levam ao seu advertorial — os mesmos passos: criativos → texto → publicar.',
      },
      edit: {
        title: 'Ver todos os seus advertoriais',
        desc: 'Abra, edite com IA ou crie anúncios para qualquer advertorial anterior.',
        cta: 'Ver todos',
      },
    },
  },
  products: {
    title: 'Produtos',
    subtitle: 'Tudo o que a Autonoma criou ou que vive na sua loja',
    createNew: 'Criar novo produto',
    createImages: 'Criar imagens',
    createPage: 'Criar página de produto',
    loading: 'Carregando os seus produtos…',
    loadError: 'Não foi possível carregar os seus produtos',
    emptyTitle: 'Ainda não há produtos',
    emptyBody: 'Crie o seu primeiro produto — envie uma foto e criamos o produto, as imagens e a página.',
    statusActive: 'Ativo',
    statusDraft: 'Rascunho',
  },
  newProduct: {
    addPhotos: 'Adicionar fotos do produto',
    variantName: 'Nome da variante',
    variantNameN: 'Nome da variante {n}',
    title: 'Novo produto',
    subtitle: 'Envie fotos do seu produto (URL opcional) — a Autonoma cria o produto e a página',
    startError: 'Não foi possível iniciar a criação',
    barTitle: 'Quando você quiser',
    barReady: 'Criaremos o produto, as imagens e a página — cerca de 5 minutos.',
    barNeedPhoto: 'Envie pelo menos uma foto do produto para começar.',
    starting: 'Iniciando…',
    generateOne: 'Gerar produto + página',
    generateMany: 'Gerar {n} produtos + páginas',
    progressTitle: 'Criando o seu produto e a sua página',
    progressSteps: {
      read: 'Lendo as suas fotos e notas',
      write: 'Escrevendo o seu produto e a sua página',
      images: 'Criando imagens do produto',
      shopify: 'Configurando tudo na Shopify',
    },
    cancelBuild: 'Cancelar esta criação',
    cancelConfirm: 'Cancelar esta criação?',
    cancelTitle: 'Cancelar criação',
    cancelIt: 'Cancelar',
    previewError: 'Não foi possível carregar a pré-visualização da página',
    loadingPreview: 'Carregando a pré-visualização da sua página…',
    sections: {
      photos: 'Fotos',
      source: 'Origem · opcional',
      details: 'Detalhes · opcional',
      style: 'Estilo da página',
    },
  },
  createImages: {
    settingsSummary: '{product} · {n} imagens neste lote',
    newBatch: 'Novo lote',
    title: 'Criar imagens de produto',
    subtitle: 'Fotografia de produto nova com IA a partir das suas fotos atuais',
    progressTitle: 'Criando {n} imagens…',
    progressSteps: {
      study: 'Estudando o seu produto…',
      design: 'Planejando cada foto…',
      render: 'Gerando imagens…',
      finish: 'Últimos retoques…',
    },
    cancelConfirm: 'Cancelar a criação destas imagens?',
    cancelTitle: 'Cancelar imagens',
    publishedTitle: '{n} imagens publicadas no seu produto 🎉',
    publishedBody: 'A primeira é agora a imagem principal do produto.',
    nextAds: 'Criar anúncios com estas imagens',
    barTitle: 'Imagens do produto',
    barSelected: '{n} de {total} selecionadas',
    downloadSelected: 'Baixar {n} selecionadas',
    downloadAll: 'Baixar todas',
    publishN: 'Publicar {n} na página de produto',
  },
  createPage: {
    title: 'Criar página de produto',
    subtitle: 'Uma página de produto de alta conversão para um produto existente',
    progressTitle: 'Criando a sua página de produto…',
    progressPreview: 'Preparando a pré-visualização…',
    alreadyGenerating: 'Já existe uma página sendo criada para este produto — acompanhe o progresso no indicador no canto inferior direito.',
  },
  upsell: {
    title: 'Descoberta de upsell',
    subtitle: 'Encontre produtos complementares que concorrentes vendem junto com os seus — o jeito mais rápido de aumentar o ticket médio',
    flowPick: 'Escolher upsell',
    previewTitle: 'Pré-visualize o seu upsell',
    publishedTitle: 'Upsell publicado',
    previewSubtitle: '“{upsell}” como complemento opcional de “{main}”',
    liveTitle: 'O seu upsell está ativo 🎉',
    liveBody: 'Aparece como complemento opcional ao lado de Adicionar ao carrinho em “{main}”. Quem o marcar recebe os dois itens juntos no carrinho.',
    liveBodyNoBlock: 'O produto de upsell e a sua página estão publicados. O bloco de complemento precisa de um passo manual — veja abaixo.',
    blockManualTitle: 'Adicione o bloco de complemento à sua página de produto',
    viewMainPage: 'Ver a página do produto',
    viewUpsellPage: 'Ver a página do upsell',
    nothingLiveTitle: 'Nada está publicado ainda',
    nothingLiveBody: 'Reveja as duas peças abaixo e ajuste-as até ficar satisfeito; depois publique. Publicar ativa o produto de upsell, coloca a sua página no ar e adiciona o bloco de complemento opcional ao lado de Adicionar ao carrinho em “{main}”.',
    barLive: 'Publicado na sua loja',
    barDraft: 'Rascunho — publique as duas peças com um clique',
    publishError: 'Não foi possível publicar o upsell',
    publishAll: 'Publicar upsell',
    republish: 'Publicar novamente',
    discoverProgressTitle: 'Procurando upsells',
    discoverSteps: {
      scan: 'Analisando o seu catálogo',
      research: 'Pesquisando o que combina bem',
      rank: 'Classificando as melhores combinações',
    },
    buildProgressTitle: 'Criando “{name}”',
    yourUpsell: 'o seu upsell',
    buildSteps: {
      product: 'Criando o produto de upsell',
      page: 'Escrevendo a sua página de produto',
      block: 'Desenhando o bloco de complemento',
    },
    noneTitle: 'Nenhuma recomendação foi encontrada',
    noneBody: 'Isso acontece de vez em quando — tente novamente daqui a pouco.',
    next: {
      ads: {
        title: 'Criar anúncios para o produto principal',
        desc: 'Envie tráfego para a página que agora inclui o upsell.',
        cta: 'Criar anúncios',
      },
      another: {
        title: 'Encontrar outro upsell',
        desc: 'Adicione mais complementos a outros produtos.',
        cta: 'Encontrar upsells',
      },
    },
  },
  splitTesting: {
    metrics: {
      variant: 'Cada versão em teste',
      split: 'Parcela de visitantes que vê esta versão',
      sessions: 'Visitas a esta versão',
      purchases: 'Pedidos desta versão',
      revenue: 'Vendas desta versão',
      cvr: 'Taxa de conversão — pedidos ÷ visitas',
      aov: 'Valor médio do pedido — receita ÷ pedidos',
      roas: 'Retorno sobre o investimento em anúncios — receita ÷ gasto com anúncios',
      rpv: 'Receita por visitante — receita ÷ visitas',
      legendProb: 'P(best) = chance de esta versão ser a melhor',
      legend: 'CVR = taxa de conversão · AOV = valor médio do pedido · ROAS = retorno sobre anúncios · ★ = objetivo deste teste',
    },
    title: 'Testes A/B',
    subtitle: 'Teste preços, páginas e ofertas — descubra o que converte melhor',
    tabs: {
      create: 'Criar novo',
      active: 'Ativos',
      paused: 'Pausados',
      completed: 'Concluídos',
    },
    flow: {
      type: 'Tipo de teste',
      setup: 'Configurar',
      launch: 'Pré-visualizar e lançar',
    },
    pickProduct: 'Escolha um produto',
    whatToTest: 'O que você quer testar?',
    previewVariants: 'Pré-visualize as suas variantes',
    progressTitle: 'Criando as suas variantes…',
    progressSteps: {
      read: 'Lendo a sua página atual…',
      write: 'Escrevendo cada variante…',
      images: 'Criando imagens…',
      preview: 'Preparando as pré-visualizações…',
    },
    cancelBuild: 'Cancelar esta criação',
    cancelConfirm: 'Cancelar a criação destas variantes?',
    cancelTitle: 'Cancelar criação',
    buildFailedTitle: 'Não conseguimos criar as variantes',
    buildFailedHint: 'Ajuste as descrições das variantes acima e tente novamente.',
    runningTitle: 'O seu teste está em andamento 🎉',
    runningBody: 'O tráfego já está sendo dividido entre as suas variantes. Os resultados são atualizados em tempo real à medida que os visitantes chegam.',
    viewResults: 'Ver resultados',
    viewActive: 'Ver testes ativos',
    createTest: 'Criar um teste',
    emptyActiveTitle: 'Nenhum teste ativo',
    emptyActiveBody: 'Testar continuamente é como as lojas crescem — comece com um teste de preço ou oferta.',
    emptyPausedTitle: 'Nenhum teste pausado',
    emptyPausedBody: 'Pausar um teste interrompe a divisão de tráfego e a coleta de dados — retome quando quiser e continue de onde parou.',
    parity: {
      blockedTitle: 'Este produto não pode rodar um teste com produto variante',
      warnTitle: 'Atenção: apps vinculados a este produto',
      warnFooter: 'Testes de preço, imagem, oferta e bundle enviam o grupo B para um produto variante. Estoque, perfil de envio e descontos ficam sincronizados automaticamente durante todo o teste; os itens acima dependem do ID do produto e podem não acompanhar. Testes de página de produto com suas próprias URLs não são afetados.',
    },
    storefront: {
      pauseAll: 'Pausar todos os testes ({n})',
      pauseAllHint: 'Parada de emergência: pausa todos os testes em andamento e desliga o script da loja. Os compradores veem suas páginas normais em até 60 segundos.',
      deliveryTitle: 'Seus testes ainda não alcançam os compradores',
      deliveryBody: 'Esta loja não tem nem o script tag antigo da Autonoma nem o app embed do Autonoma AI ativado, então nenhum comprador entra em um teste (a Shopify parou de permitir novos script tags em 1 de out. de 2026). Ative o app embed no editor de temas e clique em Salvar — leva menos de um minuto.',
      deliveryEnable: 'Ativar o app embed',
      pauseAllConfirm: 'Pausar todos os testes em andamento e desligar o script de split testing desta loja? Os compradores verão suas páginas normais em até 60 segundos. Você pode retomar os testes depois.',
      pausedAllNotice: '{n} teste(s) pausado(s) e script da loja desligado. Os compradores veem suas páginas normais em até 60 segundos.',
      offTitle: 'Os split tests estão DESLIGADOS na sua loja',
      offBody: 'Enquanto estiver desligado, nenhum visitante é redirecionado, nada é ocultado e nenhum carrinho é alterado — as atribuições existentes são ignoradas.',
      offPauseAll: 'Você pausou todos os testes em {since}.',
      offManual: 'O script da loja foi desligado em {since}.',
      offParity: 'A Autonoma desligou o script da loja em {since} porque um produto variante ficou diferente do original (veja o teste pausado).',
      offGlobal: 'A equipe da Autonoma desligou os split tests em todas as lojas enquanto um problema é investigado.',
      turnOn: 'Religar os split tests na loja',
      errorTitle: 'Isso não funcionou',
    },
    emptyCompletedTitle: 'Ainda não há testes concluídos',
    emptyCompletedBody: 'Os resultados aparecem aqui quando um teste atinge o seu limite de dados ou quando você o encerra.',
  },
  website: {
    title: 'Criador de sites',
    subtitle: 'Crie uma loja multi-produto — página inicial, navegação, logo, nome do negócio, políticas e marca no checkout — em torno dos produtos selecionados',
    startError: 'Não foi possível iniciar a criação do site',
    previousTitle: 'Sites anteriores',
    previousEmpty: 'Ainda não há site — crie o primeiro abaixo.',
    productsError: 'Não foi possível carregar os seus produtos',
    searchProducts: 'Buscar produtos',
    selectAll: 'Selecionar todos',
    clear: 'Limpar',
    selectedCount: '{n} de {total} selecionados',
    noMatches: 'Nenhum produto corresponde a essa busca.',
    showAll: 'Mostrar todos os {n} produtos',
    showFewer: 'Mostrar menos',
    barTitle: 'Pronto para criar',
    barNoProducts: 'Crie um produto primeiro.',
    barPickProducts: 'Selecione pelo menos um produto acima.',
    barTitlePending: 'Quase pronto',
    barNeedName: 'Adicione um nome de negócio ou marque “Deixar a IA criar o nome do meu negócio”.',
    barReady: 'Criação em torno de {n} produto(s) — cerca de 5 minutos.',
    buildCta: 'Criar o meu site',
    progressTitle: 'Criando o seu site',
    progressSteps: {
      brand: 'Definindo o nome, as cores e o logotipo da sua marca',
      homepage: 'Escrevendo a sua página inicial',
      images: 'Criando imagens do site',
      pages: 'Configurando páginas, menus e coleções',
    },
    cancelBuild: 'Cancelar esta criação',
    cancelConfirm: 'Cancelar a criação deste site?',
    cancelTitle: 'Cancelar criação do site',
    liveTitle: 'O seu site está publicado 🎉',
    liveBody: 'Página inicial, páginas Sobre e Contato, políticas, menus e coleções já estão publicados na sua loja.',
    viewStorefront: 'Ver a loja publicada',
    openAbout: 'Abrir a página Sobre',
    refineHomepage: 'Ajustar a página inicial',
    buildAnother: 'Criar outro site',
    previewReadyTitle: 'A pré-visualização do seu site está pronta',
    previewReadyBody: 'Nada está publicado ainda. Reveja a pré-visualização abaixo, descreva as alterações que quiser e publique para colocar todo o site no ar — páginas, políticas, menus e coleções incluídos.',
    logo: {
      eyebrow: 'O seu logótipo',
      title: 'Logótipo da marca',
      dims: 'PNG transparente de {w}×{h}',
      sourceGenerated: 'Gerado para {name}',
      sourceUploaded: 'O logótipo que carregou',
      sourceTheme: 'O logótipo atual do seu tema',
      sourceBrand: 'O seu logótipo de Marca da Shopify',
      download: 'Transferir PNG (280×80)',
      generateAnother: 'Gerar outro',
      uploadOwn: 'Carregar o meu',
      undo: 'Anular — repor o logótipo anterior',
      generating: 'A desenhar outro logótipo…',
      uploading: 'A carregar o seu logótipo…',
      setInTheme: 'Definido no tema “{theme}” — {where}',
      whereGlobal: 'definições do tema (seletor de imagem do logótipo)',
      whereHeader: 'secção do cabeçalho (seletor de imagem do logótipo)',
      whereBoth: 'definições do tema + secção do cabeçalho',
      keptCurrent: 'O seu logótipo atual foi mantido — nada foi substituído no tema.',
      notApplied: 'Ainda não definido no tema',
      noLogoSetting: 'Este tema não tem uma definição de imagem de logótipo — transfira o PNG e carregue-o no editor de temas.',
      willApply: 'Publique o site para o definir no cabeçalho do seu tema (140 px de largura).',
      restored: 'Logótipo anterior reposto no tema.',
      failed: 'A ação do logótipo falhou',
      choiceTitle: 'Logótipo',
      choiceHelp: 'Já tem um logótipo. Mantenha-o ou deixe a IA criar um novo (PNG transparente de 280×80).',
      useCurrent: 'Usar o meu logótipo atual',
      generateNew: 'Gerar um novo logótipo',
      currentFrom: 'Encontrado em: {where}',
      currentTheme: 'o seu tema',
      currentBrand: 'definições de Marca da Shopify',
    },
    openPreview: 'Abrir pré-visualização e publicar',
    barDraft: 'Pré-visualização — ainda não publicado',
    pages: {
      home: 'Início',
      about: 'Sobre nós',
      contact: 'Contato',
      aboutDesc: 'A página Sobre nós é escrita a partir da história da marca e criada na sua loja quando você publica o site.',
      contactDesc: 'Uma página de Contato com formulário funcional é criada na sua loja quando você publica o site.',
    },
    next: {
      ads: {
        title: 'Crie anúncios para os seus produtos',
        desc: 'Anúncios com imagem, anúncios em vídeo e textos, prontos para lançar na Meta.',
        cta: 'Criar anúncios',
      },
      split: {
        title: 'Faça testes A/B das suas páginas',
        desc: 'Teste preços, ofertas e versões de página para descobrir o que vende.',
        cta: 'Iniciar um teste A/B',
      },
    },
  },
  chat: {
    title: 'Chat IA',
    subtitle: 'Faça mudanças na sua loja, produtos e anúncios apenas pedindo',
    placeholder: 'Pergunte à Autonoma qualquer coisa sobre como fazer sua loja crescer...',
    send: 'Enviar',
    publishFailed: 'Não foi possível publicar o texto do anúncio',
  },
  settings: {
    title: 'Configurações',
    subtitle: 'Gerencie sua loja, conta de anúncios, padrões e plano',
    language: 'Idioma do app',
    languageHelp: 'Detectado automaticamente do seu admin Shopify — mude aqui se preferir. Muda o idioma do app E o idioma de todo o conteúdo gerado por IA (anúncios, páginas, advertoriais, narração de vídeos).',
    languageSaved: 'Idioma atualizado',
    dataSharingTitle: 'Insights anônimos',
    dataSharingLabel: 'Compartilhe insights de uso anonimizados e agregados para ajudar a melhorar a Autonoma.',
    dataSharingHelp: 'Ativado por padrão (você pode desativar a qualquer momento em Configurações). Quando ativado, padrões anonimizados e agregados sobre quais anúncios, páginas e ofertas convertem melhoram as recomendações da IA para todas as lojas. Nenhum dado pessoal é compartilhado — nem dados de clientes, nomes de produtos, números de vendas ou a identidade da sua loja.',
    autoImproveTitle: 'Melhoria automática',
    autoImproveLabel: 'Sugerir um teste A/B quando uma página tiver tráfego suficiente e uma taxa fraca de adicionar ao carrinho.',
    autoImproveHelp: 'Desativado até você ativar. A Autonoma mede como os visitantes percorrem as seções das páginas que criou (quais seções são vistas, por quanto tempo e onde acontece o adicionar ao carrinho — nunca quem é o visitante) e, com isso ativado, sugere um teste A/B de hero ou de oferta por página como notificação. Você revisa cada variante antes de qualquer divisão de tráfego; nada começa sozinho.',
    autoImproveStats: '{views} visualizações em {pages} páginas Autonoma nos últimos {days} dias · sugestões a partir de {min} visualizações por página.',
    autoImproveNoData: 'Nenhuma visualização medida ainda — páginas criadas com a biblioteca de seções atual começam a reportar assim que visitantes as acessam.',
    onThisPage: 'Nesta página',
    saveFailed: 'Não foi possível salvar',
    metaConnectError: 'Não foi possível conectar a sua conta da Meta',
    sections: {
      plan: 'Plano e uso',
      meta: 'Conta de anúncios da Meta',
      defaults: 'Padrões de anúncios',
      themeEditor: 'Editor de temas',
      mobile: 'App móvel',
      referrals: 'Indique e ganhe',
      privacy: 'Privacidade',
    },
  },
  plans: {
    title: 'Escolha seu plano',
    subtitle: '{plans} incluem {n} dias de teste grátis. Cancele quando quiser.',
    subtitleNoTrial: 'Cancele quando quiser.',
    andPlans: 'e',
    perMonth: '/mês',
    trialChip: '{n} dias de teste grátis',
    billedToday: 'Cobrado hoje',
    mostPopular: 'Mais popular',
    startTrial: 'Começar teste grátis',
    choose: 'Escolher {name}',
    opening: 'Abrindo a Shopify…',
    loading: 'Carregando planos',
    loadError: 'Não foi possível carregar os planos — atualize a página.',
    declined: 'Você precisa aceitar um plano para continuar — escolha um abaixo para começar.',
    unverified: 'Ainda não conseguimos confirmar sua assinatura com a Shopify. Se você aprovou a cobrança, clique em “Verificar novamente”; caso contrário, escolha um plano abaixo.',
    checkAgain: 'Verificar novamente',
    checking: 'Verificando…',
    contactSupport: 'Falar com o suporte',
    reactivateTitle: 'Sua assinatura está inativa',
    reactivateSubtitle: 'Reative para restaurar suas páginas, produtos e anúncios — nada é apagado.',
    reactivateReason: {
      cancelled: 'Sua assinatura da Autonoma foi cancelada.',
      frozen: 'Sua assinatura está congelada — a Shopify não conseguiu cobrar o último pagamento.',
      declined: 'A cobrança da assinatura foi recusada.',
      expired: 'Sua assinatura expirou.',
      pending: 'Sua assinatura ainda aguarda aprovação na Shopify.',
      test_charge_on_live_store: 'Esta assinatura de teste não é válida em uma loja real.',
      inactive: 'Sua assinatura da Autonoma não está mais ativa.',
    },
    reactivateCta: 'Reativar {name}',
    unavailableTitle: 'Não conseguimos confirmar sua assinatura',
    unavailableBody: 'A Shopify não respondeu a tempo, então a Autonoma ainda não pode abrir. Nada se perde — tente novamente em instantes.',
    tryAgain: 'Tentar novamente',
    checkingAccess: 'Verificando sua assinatura…',
    genericError: 'Algo deu errado — tente novamente.',
    keyNumbersTitle: 'Por mês',
    notIncluded: 'Não incluído',
    inherits: 'Tudo do {name}, mais:',
    customLine: 'Precisa de limites maiores ou white-label? Planos sob medida para agências e marcas de alto volume —',
    customCta: 'Agendar uma conversa →',
    compare: 'Comparar todos os recursos',
    close: 'Fechar',
    trustRow: 'Cobrança segura pela Shopify · Cancele quando quiser · Mude de plano a qualquer momento',
    consentTitle: 'Compartilhe insights anônimos para ajudar a melhorar a Autonoma',
    consentBody: 'Compartilhe insights de uso anonimizados e agregados para ajudar a melhorar a Autonoma. Nenhum dado pessoal é compartilhado. Você pode mudar isso a qualquer momento em Configurações.',
    consentDefault: 'Ativado por padrão (você pode desativar a qualquer momento em Configurações).',
    consentInfo: 'Mais sobre o compartilhamento de insights anônimos',
    billingNote: 'A cobrança é feita com segurança pela Shopify e aparece na sua fatura da Shopify. Ao assinar, você concorda com nossos',
    and: 'e a',
    terms: 'Termos de serviço',
    privacy: 'Política de privacidade',
    // Client fallback for backends without plan.copy.tagline / highlights
    // (the server copy in plan-copy.service.js is the source of truth).
    tiers: {
      starter: {
        tagline: 'Lance os primeiros produtos vencedores',
        highlights: ['Páginas de produto com IA', 'Anúncios com selos de oferta', 'Advertoriais que pré-vendem', 'Site de marca + logo'],
      },
      growth: {
        tagline: 'Publique anúncios e eleve o ticket',
        highlights: ['Publique anúncios na Meta', 'Anúncios de feed vertical (4:5)', 'Upsells pós-compra', 'App para iPhone e Android'],
      },
      scale: {
        tagline: 'Vídeo, testes A/B e chat com IA',
        highlights: ['Anúncios em vídeo com IA', 'Testes A/B com vencedor claro', 'Assistente IA que faz o trabalho', 'Suporte prioritário'],
      },
      enterprise: {
        tagline: 'Para agências e marcas de alto volume',
        highlights: ['Limites máximos em tudo', 'Teste ângulos novos todo dia', 'Onboarding dedicado', 'Suporte prioritário'],
      },
    },
    keyNumbers: {
      productBuilds: 'Páginas de produto',
      imageAds: 'Anúncios de imagem',
      videoAds: 'Anúncios em vídeo',
      advertorials: 'Advertoriais',
      splitTests: 'Testes A/B',
      findProductsSearches: 'Buscas de produtos',
    },
    currentPlan: 'Plano atual',
  },
  planLimit: {
    titleReached: 'Você atingiu o limite do seu plano',
    titleNotEnough: 'Não resta o suficiente este mês',
    titleNear: 'Está acabando este mês',
    reached: 'Você usou todos os {n} {feature} do {plan} este mês. Faça upgrade para continuar criando — seu limite reinicia em {date}.',
    reachedBudget: 'Você usou todo o seu {feature} de {n} no {plan} este mês. Faça upgrade para continuar criando — seu limite reinicia em {date}.',
    notEnough: 'Restam {x} {feature} este mês. Isto precisa de {y}. Faça upgrade do seu plano para fazer isso agora.',
    notEnoughBudget: 'Restam {x} de {feature} este mês. Isto precisa de {y}. Faça upgrade do seu plano para fazer isso agora.',
    notEnoughUnknown: 'Restam {x} {feature} este mês — não é suficiente para isto. Faça upgrade do seu plano para fazer isso agora.',
    left: 'Restam {x} {feature} este mês.',
    allowance: '{n} {feature} / mês',
    allowanceBudget: '{n} {feature} / mês',
    allowanceUnlimited: '{feature} ilimitados',
    allowanceNone: 'Não incluído neste plano',
    topTierTitle: 'Você está no nosso plano mais alto',
    topTierBody: 'Precisa de mais {feature} este mês? Criamos planos personalizados com limites maiores para agências e marcas de alto volume.',
    topTierCta: 'Fale conosco sobre um plano personalizado',
    referLine: 'Ou indique uma loja — vocês dois ganham créditos bônus.',
    referCta: 'Indique e ganhe',
    nearLimit: 'Restam {n} {feature} este mês',
    nearLimitBudget: 'Restam {n} de {feature} este mês',
    viewPlans: 'Ver planos',
    upgraded: 'Plano atualizado — você já pode gerar.',
    loadError: 'Não foi possível carregar os planos — tente novamente.',
    subscribeError: 'Não foi possível iniciar o upgrade — tente novamente.',
    close: 'Fechar',
  },
  generations: {
    title: 'Criações anteriores',
    tabAll: 'Todas',
    tabTrash: 'Lixeira',
    trashNote: 'Os itens excluídos ficam aqui por {n} dias — restaure-os ou exclua-os permanentemente.',
    trashEmpty: 'A lixeira está vazia.',
    empty: 'Nada criado ainda.',
    viewEdit: 'Ver / editar',
    moveToTrash: 'Mover para a lixeira',
    restore: 'Restaurar',
    deleteForever: 'Excluir permanentemente',
    deletedIn: 'excluído permanentemente {when}',
    status: {
      draft: 'Rascunho',
      published: 'Publicado',
      replaced: 'Substituído',
      trashed: 'Na lixeira',
    },
  },
  productDetail: {
    loading: 'Carregando produto…',
    loadError: 'Não foi possível carregar este produto',
    backToProducts: 'Voltar aos produtos',
    editInShopify: 'Editar na Shopify',
    draftNote: 'Rascunho — publique o produto na Shopify para obter o link da página publicada.',
    whatToCreate: 'O que você quer criar?',
    pagesTitle: 'Páginas de produto deste produto',
    pagesEmpty: 'Ainda não foi criada nenhuma página para este produto.',
    pagesEmptyCta: 'Criar a página de produto',
    othersTitle: 'Advertoriais e pacotes de anúncios deste produto',
    othersEmpty: 'Ainda não há advertoriais nem pacotes de anúncios.',
    chatPrompt: 'Prefere apenas descrever a alteração?',
    chatCta: 'Conversar com a IA',
    actions: {
      ads: {
        title: 'Criar anúncios para este produto',
        desc: 'Criativos com imagem e vídeo, prontos para publicar na Meta.',
      },
      images: {
        title: 'Criar imagens do produto',
        desc: 'Nova fotografia de produto com IA a partir das suas fotos atuais.',
      },
      page: {
        title: 'Criar página de produto',
        desc: 'Uma página de produto de alta conversão no estilo que você escolher.',
      },
      advertorial: {
        title: 'Criar advertorial',
        desc: 'Um artigo em estilo editorial que vende — história, pesquisa, lista.',
      },
      splitTest: {
        title: 'Criar teste A/B',
        desc: 'Compare preços, ofertas ou páginas de produto entre si.',
      },
      upsell: {
        title: 'Encontrar produtos de upsell',
        desc: 'Descubra produtos complementares que aumentam o seu ticket médio.',
      },
    },
  },
  flow: {
    product: 'Produto',
    build: 'Criação',
    review: 'Revisão',
    publish: 'Publicar',
    setup: 'Configuração',
    customise: 'Personalizar',
    preview: 'Pré-visualização',
    results: 'Resultados',
  },
  findProducts: {
    title: 'Encontrar produtos',
    subtitle: 'Produtos vencedores comprovados por investimento real em anúncios — novas seleções a cada busca',
    progressTitle: 'Procurando produtos vencedores',
    progressSteps: {
      scan: 'Analisando o que está vendendo agora',
      filter: 'Filtrando para o seu nicho',
      rank: 'Classificando as melhores opções',
    },
    cancelConfirm: 'Cancelar esta busca?',
    cancelTitle: 'Cancelar busca',
    noneTitle: 'Nenhum produto vencedor nesta categoria',
    noneBody: 'Tente outra categoria ou repita a busca — as seleções se renovam a cada vez.',
  },
  ui: {
    nav: {
      menuLabel: 'Menu de navegação',
      lockedTitle: 'Faça upgrade para desbloquear {name}',
    },
    progress: {
      done: 'Pronto!',
      anyMoment: 'A qualquer momento…',
      longer: 'Está demorando um pouco mais que o normal…',
      minutesLeft: 'Faltam cerca de {n} min',
      oneMinuteLeft: 'Falta cerca de 1 min',
      secondsLeft: 'Faltam cerca de {n} s',
      leaveNote: 'Avisaremos quando terminar — você pode sair desta página.',
      cancel: 'Cancelar',
    },
    errors: {
      retry: 'Tentar novamente',
      reload: 'Recarregar a página',
      showDetails: 'Detalhes técnicos',
      hideDetails: 'Ocultar detalhes',
      generic: {
        title: 'Algo não funcionou',
        body: 'Tente novamente. Se continuar acontecendo, fale conosco pelo botão de suporte.',
      },
      network: {
        title: 'Não foi possível conectar à Autonoma',
        body: 'Verifique a sua conexão com a internet e tente novamente.',
      },
      session: {
        title: 'A sua sessão expirou',
        body: 'Recarregue a página para entrar novamente — o seu trabalho está salvo.',
      },
      quota: {
        title: 'Você atingiu o limite do seu plano',
        body: 'Faça upgrade do plano ou aguarde o próximo período de cobrança para continuar.',
      },
      notFound: {
        title: 'Não encontramos isso',
        body: 'Pode ter sido removido. Volte e tente novamente.',
      },
      busy: {
        title: 'Já está em andamento',
        body: 'Isto já está em progresso — veja o indicador no canto inferior direito.',
      },
      tooLarge: {
        title: 'Esse arquivo é grande demais',
        body: 'Tente um arquivo menor.',
      },
      rateLimit: {
        title: 'Solicitações demais',
        body: 'Aguarde um minuto e tente novamente.',
      },
      timeout: {
        title: 'Isto demorou demais',
        body: 'A solicitação expirou. Tente novamente — normalmente funciona na segunda vez.',
      },
      server: {
        title: 'Algo deu errado do nosso lado',
        body: 'Tente novamente daqui a pouco.',
      },
    },
    preview: {
      label: 'Pré-visualização',
      device: 'Dispositivo da pré-visualização',
      desktop: 'Desktop',
      mobile: 'Celular',
      edit: 'Editar',
      clickToEdit: 'Pré-visualização · clique para editar',
      editPage: 'Editar esta página',
    },
    success: {
      whatNext: 'O que você quer fazer agora?',
    },
    session: {
      title: 'Não foi possível conectar à sua loja',
      body: 'Sua sessão do Shopify não está funcionando agora. Reconectar costuma resolver.',
    },
    themeCode: {
      getting: 'Obtendo seu código…',
      error: 'Não foi possível obter seu código',
    },
    editor: {
      opening: 'Abrindo sua página…',
      archivedTitle: 'Esta página foi arquivada',
      openError: 'Não foi possível abrir esta página',
      publishError: 'A publicação não foi concluída',
      upToDate: '✓ No ar · atualizado',
      upToDateHint: 'Tudo nesta página está no ar. Faça uma alteração e o botão Publicar volta a aparecer.',
      back: '← Voltar',
    },
    jobs: {
      ads: 'Criando anúncios',
      advertorial: 'Criando o advertorial',
      landing_page: 'Criando a página do produto',
      website: 'Criando o site',
      images: 'Criando imagens',
      product_build: 'Criando o produto',
      split_test_build: 'Criando as variantes do teste',
      split_test_setup: 'Configurando o teste A/B',
      upsell_discovery: 'Procurando upsells',
      upsell_build: 'Criando o upsell',
      product_finder: 'Procurando produtos vencedores',
      edit_own_ad: 'Editando seus anúncios',
      ad_copy: 'Escrevendo o texto do anúncio',
      cart_upgrade: 'Atualizando seu carrinho',
      publish_ads: 'Publicando anúncios',
      shipping_setup: 'Configurando o frete',
      markets_update: 'Atualizando mercados',
      working: 'Trabalhando',
      updating: 'Atualizando seu {what}',
    },
  },
  feedback: {
    thanksTitle: 'Obrigado pelo feedback',
    gotIt: 'Recebido — ticket #{ticket}',
    gotItBody: 'Uma pessoa real da equipe da Autonoma lê cada uma destas mensagens. Se precisarmos de mais detalhes, responderemos ao e-mail da sua loja{email}.',
    backToDashboard: 'Voltar ao painel',
    sendAnother: 'Enviar outro',
  },
  featureRequest: {
    button: 'Pedir um recurso',
    title: 'Pedir um recurso',
    intro: 'Conte o que você gostaria que a Autonoma fizesse — novos recursos, melhorias, qualquer coisa. Lemos todos os pedidos.',
    label: 'Seu pedido',
    placeholder: 'ex.: Quero agendar anúncios para começar em um horário definido…',
    send: 'Enviar pedido',
    tooShort: 'Conte um pouco mais (pelo menos 10 caracteres).',
    tooLong: 'Mantenha seu pedido com menos de 2.000 caracteres.',
    successTitle: 'Obrigado — seu pedido foi enviado.',
    successBody: 'Entraremos em contato se precisarmos de mais detalhes.',
    reference: 'Referência nº {ticket}',
    errorGeneric: 'Não foi possível enviar seu pedido — tente novamente.',
    retry: 'Tentar novamente',
  },
  referAndEarn: {
    shareYourLink: 'Compartilhe seu link',
  },
  // Espaço "Revisar e publicar"
  review: {
    top: {
      back: 'Voltar',
      breadcrumb: 'Onde você está',
      live: 'No ar na sua loja',
      draft: 'Rascunho — ainda não publicado',
      page: 'Página',
      part: 'Parte da página',
      productCard: 'Cartão do produto',
      landingPage: 'Landing page',
      undo: 'Desfazer',
      redo: 'Refazer',
      history: 'Histórico de versões',
      themeEditor: 'Abrir no editor de tema',
      viewOnStore: 'Ver na loja',
      panel: 'Mostrar ou ocultar o painel de edição',
      zoom: 'Zoom da pré-visualização',
      zoomFit: 'Ajustar',
      expand: 'Ampliar pré-visualização',
      collapse: 'Sair da tela cheia',
    },
    canvas: {
      toolbar: 'Ações para {label}',
      editWithAi: 'Editar com IA',
      replaceImage: 'Substituir imagem',
      moveUp: 'Mover para cima',
      moveDown: 'Mover para baixo',
      duplicate: 'Duplicar',
      hide: 'Ocultar',
      show: 'Mostrar',
      delete: 'Excluir',
      deleteIt: 'Excluir',
      thisElement: 'este elemento',
      deleteConfirm: 'Excluir “{label}”? Você pode desfazer depois.',
      locked: 'Os botões de compra não são editados aqui',
      updating: 'Atualizando {label}…',
      updatingPage: 'Atualizando a página inteira…',
      saving: 'Salvando…',
      failed: 'A alteração não foi aplicada',
      failedOn: 'A alteração em {label} não foi aplicada',
      retry: 'Tentar de novo',
      plainFallback: 'mostrando a prévia simples.',
    },
    composer: {
      editing: 'Editando: {label}',
      wholePage: 'Página inteira',
      clearScope: 'Limpar a seleção',
      placeholder: 'Descreva uma alteração para a página inteira…',
      placeholderScoped: 'Descreva uma alteração para {label}…',
      wholePageBusy: 'Atualizando a página inteira — você pode continuar olhando.',
      cancelConfirm: 'Cancelar esta atualização?',
      cancelTitle: 'Cancelar atualização',
      cancelIt: 'Cancelar',
    },
    prompts: {
      pagePremium: 'Tom mais premium',
      pageShorter: 'Encurtar tudo em 20%',
      pageFaq: 'Adicionar uma seção de perguntas frequentes',
      pageStory: 'Deixar a história mais pessoal',
      pageCta: 'Fortalecer a chamada para ação',
      headlinePunchier: 'Título mais impactante',
      headlineShorter: 'Encurtar',
      headlineBenefit: 'Começar pelo benefício principal',
      textTighter: 'Enxugar o texto',
      textConcrete: 'Deixar mais concreto',
      textFriendly: 'Deixar mais amigável',
      buttonAction: 'Orientado à ação',
      buttonUrgency: 'Adicionar um toque de urgência',
      imageLifestyle: 'Usar uma imagem lifestyle',
      imageBrighter: 'Fundo mais claro e limpo',
      sectionTrust: 'Adicionar selos de confiança',
      sectionTighter: 'Enxugar o texto',
      sectionTestimonial: 'Adicionar um depoimento',
    },
    panel: {
      label: 'Painel de edição',
      collapse: 'Recolher o painel',
      open: 'Painel',
      tabs: { edit: 'Editar', sections: 'Seções', images: 'Imagens', brand: 'Marca', details: 'Detalhes' },
    },
    edit: {
      emptyTitle: 'Nada selecionado',
      emptyBody: 'Clique em qualquer parte da página para editá-la.',
      inSection: 'em {section}',
      noFields: 'Esta parte não tem campos de texto ou imagem — use “Editar com IA”.',
      buttonLabel: '{label} · texto',
      buttonLink: '{label} · link',
      saved: 'Salvo',
      hintEnter: 'Enter para salvar',
      hintBlur: 'Salva ao sair do campo',
      replace: 'Substituir',
      generate: 'Gerar',
      upload: 'Enviar',
      uploading: 'Enviando…',
      uploadFailed: 'Não foi possível enviar a imagem.',
      pickImage: 'Escolha uma imagem',
      noLibrary: 'Ainda não há imagens geradas para este produto — envie uma.',
      useImage: 'Usar imagem',
      generatePrompt: 'Gere uma nova imagem para este espaço — mesmo produto, composição mais limpa. Anexe uma referência se quiser um visual específico.',
    },
    sections: {
      hide: 'Ocultar {label}',
      show: 'Mostrar {label}',
      none: 'Nenhuma seção encontrada nesta página.',
      add: 'Adicionar seção',
      dragHint: 'Arraste a alça para reordenar. Seções ocultas continuam na página, mas não aparecem na sua loja.',
      libraryTitle: 'Adicionar uma seção',
      libraryHint: 'A IA escreve a seção para esta página e a coloca depois da parte que você está vendo.',
      placeAfter: 'Coloque-a logo depois da seção “{section}”.',
      library: {
        benefits: { name: 'Benefícios', desc: 'Três a quatro benefícios com ícones.', instruction: 'Adicione uma seção de benefícios com 3–4 benefícios concretos, cada um com um título curto, uma frase e um ícone simples.' },
        testimonials: { name: 'Depoimentos', desc: 'Citações de clientes com nomes e avaliações.', instruction: 'Adicione uma seção de depoimentos com três citações críveis, primeiros nomes, cidades e avaliações de 5 estrelas.' },
        faq: { name: 'Perguntas frequentes', desc: 'Cinco dúvidas comuns antes da compra.', instruction: 'Adicione uma seção de perguntas frequentes com cinco dúvidas reais antes da compra e respostas concretas e tranquilizadoras.' },
        gallery: { name: 'Galeria de imagens', desc: 'Uma grade com as imagens existentes.', instruction: 'Adicione uma galeria usando apenas imagens que já estão na página, em uma grade limpa.' },
        comparison: { name: 'Tabela comparativa', desc: 'Nós versus as alternativas comuns.', instruction: 'Adicione uma tabela comparativa: este produto versus alternativas típicas, 4–5 linhas, com marcas de certo e errado.' },
        howItWorks: { name: 'Como funciona', desc: 'Três passos numerados.', instruction: 'Adicione uma seção “Como funciona” com três passos numerados, cada um com um título curto e uma frase.' },
        guarantee: { name: 'Garantia', desc: 'Promessa de reembolso e notas de envio.', instruction: 'Adicione uma seção de garantia: promessa de reembolso, envio e devoluções em palavras simples, com um selo.' },
        cta: { name: 'Chamada para ação', desc: 'Um banner final com botão.', instruction: 'Adicione um banner final de chamada para ação com um título forte, uma linha de confiança e um botão ligando ao botão de compra ou produto existente.' },
      },
    },
    brand: {
      noLogo: 'Ainda não foi gerado um logotipo para este site.',
      colours: 'Cores da marca',
      fonts: 'Fontes',
      change: 'Alterar',
      noColours: 'As cores da marca vêm do seu tema.',
      headingFont: 'Títulos',
      bodyFont: 'Texto',
      themeDefault: 'Padrão do tema',
    },
    details: {
      product: 'Produto',
      title: 'Título',
      price: 'Preço',
      compareAt: 'Preço comparativo',
      none: 'Nenhum',
      status: 'Status',
      productHint: 'Título, preço e preço comparativo são lidos do Shopify. Edite-os lá — a página é atualizada ao publicar.',
      editInShopify: 'Editar produto no Shopify',
      advertorial: 'Advertorial',
      headline: 'Título',
      linkedProduct: 'Produto vinculado',
      ctaOk: 'A chamada para ação leva a {product}.',
      ctaOther: 'A chamada para ação leva a outro produto.',
      ctaMissing: 'Nenhum link para o produto foi encontrado — adicione um para que os leitores possam comprar.',
      openProduct: 'Abrir produto',
    },
    pages: {
      publishesWithSite: 'Esta página é criada quando você publica o site.',
    },
    coach: {
      step: '{n} de {total}',
      clickTitle: 'Clique em qualquer parte para editar',
      clickBody: 'Passe o mouse para ver o que pode mudar, clique para selecionar — depois use a barra flutuante ou o painel à direita.',
      composerTitle: 'Ou descreva uma alteração aqui',
      composerBody: 'Escreva o que quer com suas palavras. Com algo selecionado, a alteração fica dentro dele; senão, vale para a página inteira.',
      publishTitle: 'Publique quando estiver satisfeito',
      publishBody: 'Nada vai ao ar até você clicar em Publicar. Toda alteração é salva e pode ser desfeita.',
      skip: 'Pular',
      gotIt: 'Entendi',
    },
    bar: {
      publish: 'Publicar na minha loja',
      update: 'Atualizar página publicada',
      publishing: 'Publicando…',
      saveDraft: 'Salvar rascunho',
      checking: 'Verificando…',
      review: 'Revisar',
      oneIssue: '1 problema bloqueia a publicação',
      nIssues: '{n} problemas bloqueiam a publicação',
      oneSuggestion: '1 sugestão',
      nSuggestions: '{n} sugestões',
      blockedTooltip: 'A publicação está bloqueada',
      blockedTooltipAction: 'Clique para revisar e corrigir.',
      blockedBy: 'bloqueado por {n} problema(s)',
      whyBlocked: 'Por que não consigo publicar? Veja os problemas',
      savedJustNow: 'Salvo agora mesmo',
      savedAgo: 'Salvo há {n} min',
      allSaved: 'Todas as alterações salvas',
    },
  },
};

export default pt;
